<template>
  <div>
    <h2>
      <el-button class="pull-right"
                 v-if="canAdd()"
                 @click="showDialog()" type="primary">Nuevo</el-button>
      Roles
    </h2>
    <app-table
      @change-pagination="onChangePagination"
      @change-search="onChangeSearch"
      :total="total">

      <el-table
        v-loading="loading"
        :data="tableData"
        style="width: 100%">
        <el-table-column
          prop="name"
          label="Nombre">
        </el-table-column>
        <el-table-column
          prop="display_name"
          label="Descripción">
        </el-table-column>
        <el-table-column
          width="100">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="warning"
              v-if="scope.row.id > 2 && canUpdate()"
              @click="showDialog(scope.row)">
              <i class="el-icon-edit"></i>
            </el-button>
            <el-button
              size="mini"
              type="warning"
              v-if="scope.row.id > 2 && !canUpdate() && canShow()"
              @click="showDialog(scope.row)">
              <i class="el-icon-edit"></i>
            </el-button>
            <el-button
              type="danger"
              size="mini"
              v-if="scope.row.id > 2 && canDelete()"
              @click="handleDelete(scope.$index, scope.row)">
              <i class="el-icon-delete"></i>
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </app-table>

    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible">
      <el-form ref="form" :model="form" :rules="rules" label-position="top">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="Nombre" prop="name">
              <el-input v-model="form.name" placeholder="Nombre"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Descripción" prop="display_name">
              <el-input v-model="form.display_name" placeholder="Descripción"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div v-if="form.id" class="permissions">
        <!--<div class="search">-->
          <!--<el-input type="search" v-model="permissionSearch" placeholder="Buscar Permiso"></el-input>-->
        <!--</div>-->
        <div class="grid-columns">
          <el-card class="box-card" v-for="(module, index) in modules" :key="module.id">
            <div slot="header" class="clearfix">
              <label :for="'module' + index">
                <input type="checkbox"
                       :id="'module' + index"
                       :disabled="moduleIsDisabled(index)"
                       @change="onChangeModule(module, index)"
                       v-model="module.active">
                {{ module.name }}</label>
            </div>
            <div  v-for="permission in module.permissions" :key="permission.id" class="text item">
              <label :for="'perm' + permission.id">
                <input type="checkbox"
                       :id="'perm' + permission.id"
                       :disabled="permissionIsDisabled(permission.id) || moduleIsDisabled(index)"
                       @change="onChangePermission(module, permission)"
                        v-model="permission.active">
                {{ permission.display_name }}
              </label>
            </div>
          </el-card>
        </div>
      </div>
      <div role="alert" v-if="error.message" class="el-alert el-alert--error">
        <div class="el-alert__content">
          <span class="el-alert__title is-bold">{{ error.message }}</span>
          <p class="el-alert__description">
          <ul>
            <li v-for="item in error.errors">{{ item[0] }}</li>
          </ul>
          </p>
        </div>
      </div>
      <el-alert
        v-if="success"
        title="Se ha guardado exitosamente."
        type="success">
      </el-alert>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">Cancelar</el-button>
        <el-button type="primary" :loading="processing" @click="save()">Guardar</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
  import AppTable from '../../components/Table'
  import BaseCrud from '../../components/abstract/BaseCrud'
  import {baseApi} from '../../configs/urls'

  export default {
    name: 'role-list',
    extends: BaseCrud,
    components: {
      AppTable
    },
    data () {
      return {
        baseUrl: baseApi + '/roles',
        permissionSearch: '',
        form: {
          name: '',
          display_name: ''
        },
        rolePermission: [],
        loadingRolePermission: false,
        permissions: [],
        disabledModules: [],
        disabledPermissions: [],
        loadingPermissions: false,
        rules: {
          name: [
            { required: true, message: 'El nombre es requerido', trigger: 'blur' }
          ],
          display_name: [
            { required: true, message: 'La descripción es requerido', trigger: 'blur' }
          ]
        }
      }
    },
    methods: {
      fetchPermissions (model) {
        this.loadingRolePermission = true
        this.$http.get(baseApi + '/permissions?role_id=' + model.id)
          .then(
            (response) => {
              let rolePermissions = response.body.map(item => item.id)
              this.rolePermission = this.permissions.map((permission) => {
                permission.active = (rolePermissions.indexOf(permission.id) > -1)
                permission.disabled = false
                return permission
              })
              this.loadingRolePermission = false
            },
            (res) => {
              this.showErrors(res)
              this.loadingRolePermission = false
            }
          )
      },
      fetchAllPermissions () {
        this.loadingPermissions = true
        this.$http.get(baseApi + '/permissions')
          .then(
            (response) => {
              this.permissions = response.body
              this.loadingPermissions = false
            },
            (res) => {
              this.showErrors(res)
              this.loadingPermissions = false
            }
          )
      },
      _formatModel (model) {
        this.fetchPermissions(model)
      },
      onChangeModule (module, index) {
        this.disabledModules.push(index)
        this.$http.post(baseApi + '/roles/' + this.form.id + '/permissions', {
          modules: [module.module],
          status: module.active
        })
          .then(
            () => {
              const permissions = module.permissions.map(item => item.id)
              this.rolePermission = this.rolePermission.map((permission) => {
                if (permissions.indexOf(permission.id) > -1) {
                  permission.active = module.active
                }
                return permission
              })
              this.enableModule(index)
            },
            (res) => {
              module.active = !module.active
              this.showErrors(res)
              this.enableModule(index)
            }
          )
      },
      enableModule (index) {
        this.disabledModules = this.disabledModules.filter(item => item !== index)
      },
      enablePermission (id) {
        this.disabledPermissions = this.disabledPermissions.filter(item => item !== id)
      },
      moduleIsDisabled (index) {
        return this.disabledModules.indexOf(index) > -1
      },
      permissionIsDisabled (id) {
        return this.disabledPermissions.indexOf(id) > -1
      },
      onChangePermission (module, permission) {
        this.disabledPermissions.push(permission.id)
        this.$http.post(baseApi + '/roles/' + this.form.id + '/permissions', {
          permissions: [permission.id],
          status: permission.active
        })
          .then(
            () => {
              const actives = module.permissions.filter((item) => item.active)
              module.active = (actives.length === module.permissions.length)
              this.enablePermission(permission.id)
            },
            (res) => {
              permission.active = !permission.active
              this.enablePermission(permission.id)
              this.showErrors(res)
            }
          )
      }
    },
    computed: {
      modules () {
        const modules = []
        let module = ''

        for (let i = 0; i < this.rolePermission.length; i++) {
          const permission = this.rolePermission[i]
          if (module !== permission.display_module_name) {
            if (modules.length > 0) {
              const permActives = modules[modules.length - 1].permissions.filter((item) => item.active)
              if (permActives.length === modules[modules.length - 1].permissions.length) {
                modules[modules.length - 1].active = true
              }
            }

            module = permission.display_module_name
            modules.push({
              id: i,
              name: module,
              module: permission.module,
              permissions: [],
              active: false,
              disabled: false
            })
          }

          modules[modules.length - 1].permissions.push(permission)
        }
        return modules
      }
    },
    mounted () {
      this.fetchAllPermissions()
    }
  }
</script>

<style>
  .permissions {
    margin-top: 10px;
  }
  .permissions .search {
    padding: 15px;
    border-top: 1px solid #ddd;
    border-bottom: 1px solid #ddd;
    margin-bottom: 25px;
  }
  .grid-columns {
    display: grid;
    grid-gap: 15px;
    grid-template-columns: 1fr 1fr 1fr;
  }
</style>



// WEBPACK FOOTER //
// src/views/roles/RoleList.vue